import { graphql } from "api/cms-website/generated";

export const ResponsiveImageFragment = graphql(/* GraphQL */ `
    fragment ResponsiveImageFragment on ComponentElementsResponsiveImage {
        id
        desktop {
            url
            width
            height
            alternativeText
        }
        mobile {
            url
            width
            height
            alternativeText
        }
        alt
    }
`);
